var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.834,
    height: 26.836,
    viewBox: "0 0 26.834 26.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9c044",
    d: "M25.121,0H1.713A1.714,1.714,0,0,0,0,1.713V25.123a1.715,1.715,0,0,0,1.713,1.713H25.121a1.714,1.714,0,0,0,1.713-1.713V1.712A1.714,1.714,0,0,0,25.121,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.18 10.863)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: "0.3px",
    d: "M8.806,10.922a7.4,7.4,0,0,1-.212,1.906A3.172,3.172,0,0,1,7.952,14.1a2.515,2.515,0,0,1-1.072.715,4.459,4.459,0,0,1-1.493.226,3.72,3.72,0,0,1-1.354-.235A2.832,2.832,0,0,1,3,14.135a2.992,2.992,0,0,1-.655-1.062,3.984,3.984,0,0,1-.231-1.391v-.334H3.726q0,2.244,1.663,2.246a2.578,2.578,0,0,0,.759-.1,1.163,1.163,0,0,0,.564-.385,1.924,1.924,0,0,0,.35-.784,5.864,5.864,0,0,0,.121-1.317V2.635H8.808v8.288Zm8.972,2.43a2.7,2.7,0,0,1-.705.887,3.38,3.38,0,0,1-1.115.593,4.793,4.793,0,0,1-1.47.211q-3.6,0-3.8-2.845h1.58q.01,1.608,2.2,1.609a3.091,3.091,0,0,0,.863-.108,1.861,1.861,0,0,0,.623-.295,1.28,1.28,0,0,0,.379-.445,1.225,1.225,0,0,0,.13-.556,1.138,1.138,0,0,0-.1-.508.853.853,0,0,0-.38-.343,4.148,4.148,0,0,0-.779-.29q-.5-.146-1.3-.357c-.522-.13-.974-.26-1.352-.39a3.233,3.233,0,0,1-.934-.469,1.7,1.7,0,0,1-.542-.683A2.6,2.6,0,0,1,10.9,8.337a2.244,2.244,0,0,1,.231-1.011,2.368,2.368,0,0,1,.661-.808,3.2,3.2,0,0,1,1.038-.536,4.476,4.476,0,0,1,1.359-.194q3.483,0,3.539,2.476H16.177q-.084-1.237-1.866-1.239a3.254,3.254,0,0,0-.734.079,2.05,2.05,0,0,0-.587.226A1.146,1.146,0,0,0,12.6,7.7a.923.923,0,0,0-.138.5,1.183,1.183,0,0,0,.065.425.67.67,0,0,0,.31.311,3.393,3.393,0,0,0,.725.282q.48.139,1.313.342.8.193,1.4.4a3.681,3.681,0,0,1,.984.5,1.816,1.816,0,0,1,.582.72,2.632,2.632,0,0,1,.189,1.062A2.5,2.5,0,0,1,17.778,13.352Z",
    transform: "translate(-2.118 -2.635)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.b2fe1b4b.svg";
export { ForwardRef as ReactComponent };